import { BaseTrigger } from './BaseTrigger';
import * as InternalTypes from '../../../common/InternalTypes';
import { LoggerTexts } from '../../../common/LoggerTexts';

export class RecurringTrigger extends BaseTrigger {
	constructor(triggerConfig: InternalTypes.RecurringTriggerConfig) {
		const { interval, maxLimit, startThreshold } = triggerConfig;
		if (!Number.isInteger(interval)) {
			throw Error(LoggerTexts.RECURRING_TRIGGER.CTOR_INTERVAL_NOT_VALID_NUMBER + interval);
		}
		if (!Number.isInteger(maxLimit)) {
			throw Error(LoggerTexts.RECURRING_TRIGGER.CTOR_MAX_LIMIT_NOT_VALID_NUMBER + maxLimit);
		}
		if (!Number.isInteger(startThreshold)) {
			throw Error(LoggerTexts.RECURRING_TRIGGER.CTOR_START_THRESHOLD_NOT_VALID_NUMBER + startThreshold);
		}
		super(interval, maxLimit, startThreshold);
	}
}
